import { createSelector } from "@reduxjs/toolkit";
import { StoreState } from "../../store";

const selector = (state: StoreState) => state.feature;

export const featureSelectors = {
  features: createSelector(selector, (state) => state.features),
};
